import LayerGroup from "ol/layer/Group";
import LayerTile from "ol/layer/Tile";
import TileWMS from "ol/source/TileWMS";

const karagatanURL = process.env.GEOSERVER;
const attEOG =
  '<a href="https://eogdata.mines.edu/vbd/">Earth Observation Group, Payne Institute for Public Policy</a>';

const viirs_2025 = new LayerGroup({
  title: "2025",
  fold: "close",
  layers: [
    ///////////monthly
    new LayerTile({
      title: "2025 January",
      visible: false,
      source: new TileWMS({
        url: karagatanURL,
        params: {
          LAYERS: "karagatan:2025_january",
          VERSION: "1.3.0",
        },
        serverType: "geoserver",
        attributions: [attEOG],
      }),
    }),
    new LayerTile({
      title: "2025 February",
      visible: false,
      source: new TileWMS({
        url: karagatanURL,
        params: {
          LAYERS: "karagatan:2025_february",
          VERSION: "1.3.0",
        },
        serverType: "geoserver",
        attributions: [attEOG],
      }),
    }),
    new LayerTile({
      title: "2025 March",
      visible: false,
      source: new TileWMS({
        url: karagatanURL,
        params: {
          LAYERS: "karagatan:2025_march",
          VERSION: "1.3.0",
        },
        serverType: "geoserver",
        attributions: [attEOG],
      }),
    }),
    new LayerTile({
      title: "2025 April",
      visible: false,
      source: new TileWMS({
        url: karagatanURL,
        params: {
          LAYERS: "karagatan:2025_april",
          VERSION: "1.3.0",
        },
        serverType: "geoserver",
        attributions: [attEOG],
      }),
    }),
    new LayerTile({
      title: "2025 May",
      visible: false,
      source: new TileWMS({
        url: karagatanURL,
        params: {
          LAYERS: "karagatan:2025_may",
          VERSION: "1.3.0",
        },
        serverType: "geoserver",
        attributions: [attEOG],
      }),
    }),

    new LayerTile({
      title: "2025 June",
      visible: false,
      source: new TileWMS({
        url: karagatanURL,
        params: {
          LAYERS: "karagatan:2025_june",
          VERSION: "1.3.0",
        },
        serverType: "geoserver",
        attributions: [attEOG],
      }),
    }),
    new LayerTile({
      title: "2025 July",
      visible: false,
      source: new TileWMS({
        url: karagatanURL,
        params: {
          LAYERS: "karagatan:2025_july",
          VERSION: "1.3.0",
        },
        serverType: "geoserver",
        attributions: [attEOG],
      }),
    }),
    new LayerTile({
      title: "2025 August",
      visible: false,
      source: new TileWMS({
        url: karagatanURL,
        params: {
          LAYERS: "karagatan:2025_aug",
          VERSION: "1.3.0",
        },
        serverType: "geoserver",
        attributions: [attEOG],
      }),
    }),
    new LayerTile({
      title: "2025 September",
      visible: false,
      source: new TileWMS({
        url: karagatanURL,
        params: {
          LAYERS: "karagatan:2025_sep",
          VERSION: "1.3.0",
        },
        serverType: "geoserver",
        attributions: [attEOG],
      }),
    }),
    new LayerTile({
      title: "2025 October",
      visible: false,
      source: new TileWMS({
        url: karagatanURL,
        params: {
          LAYERS: "karagatan:2025_oct",
          VERSION: "1.3.0",
        },
        serverType: "geoserver",
        attributions: [attEOG],
      }),
    }),
    new LayerTile({
      title: "2025 November",
      visible: false,
      source: new TileWMS({
        url: karagatanURL,
        params: {
          LAYERS: "karagatan:2025_nov",
          VERSION: "1.3.0",
        },
        serverType: "geoserver",
        attributions: [attEOG],
      }),
    }),
    new LayerTile({
      title: "2025 December",
      visible: false,
      source: new TileWMS({
        url: karagatanURL,
        params: {
          LAYERS: "karagatan:2025_december",
          VERSION: "1.3.0",
        },
        serverType: "geoserver",
        attributions: [attEOG],
      }),
    }),
    ////Weekly
  ],
});

export default viirs_2025;
